<ottimizza-center class="ottimizza-mobile-center-display" role="alert">
  <ng-content></ng-content>
</ottimizza-center>